
export interface Country {
  code: string;
  name: string;
  flag: string;
  timezone: string;
}

export const countries: Country[] = [
  { code: 'EG', name: 'Egypt مصر', flag: '🇪🇬', timezone: 'Africa/Cairo' },
  { code: 'US', name: 'United States', flag: '🇺🇸', timezone: 'America/New_York' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', timezone: 'Europe/London' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', timezone: 'America/Toronto' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', timezone: 'Australia/Sydney' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', timezone: 'Europe/Berlin' },
  { code: 'FR', name: 'France', flag: '🇫🇷', timezone: 'Europe/Paris' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', timezone: 'Europe/Madrid' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', timezone: 'Europe/Rome' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', timezone: 'Europe/Amsterdam' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', timezone: 'Asia/Tokyo' },
  { code: 'CN', name: 'China', flag: '🇨🇳', timezone: 'Asia/Shanghai' },
  { code: 'IN', name: 'India', flag: '🇮🇳', timezone: 'Asia/Kolkata' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', timezone: 'America/Sao_Paulo' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', timezone: 'America/Mexico_City' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', timezone: 'Africa/Johannesburg' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', timezone: 'Asia/Dubai' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', timezone: 'Asia/Singapore' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', timezone: 'Pacific/Auckland' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', timezone: 'Europe/Stockholm' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', timezone: 'Europe/Oslo' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', timezone: 'Europe/Copenhagen' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', timezone: 'Europe/Helsinki' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', timezone: 'Europe/Warsaw' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', timezone: 'Europe/Athens' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', timezone: 'Europe/Lisbon' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', timezone: 'Europe/Dublin' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', timezone: 'Europe/Vienna' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', timezone: 'Europe/Brussels' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', timezone: 'Europe/Zurich' },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', timezone: 'Europe/Prague' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', timezone: 'Europe/Moscow' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', timezone: 'Europe/Istanbul' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', timezone: 'Asia/Riyadh' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', timezone: 'Asia/Seoul' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', timezone: 'Asia/Bangkok' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', timezone: 'Asia/Kuala_Lumpur' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', timezone: 'Asia/Manila' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', timezone: 'Asia/Jakarta' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', timezone: 'Asia/Ho_Chi_Minh' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', timezone: 'America/Argentina/Buenos_Aires' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', timezone: 'America/Santiago' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', timezone: 'America/Bogota' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', timezone: 'America/Lima' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', timezone: 'Asia/Jerusalem' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', timezone: 'Europe/Budapest' },
];

export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code);
};

export const getCountryFlag = (code: string): string => {
  const country = getCountryByCode(code);
  return country ? country.flag : '';
};

export const getCountryName = (code: string): string => {
  const country = getCountryByCode(code);
  return country ? country.name : '';
};
